import { Component, OnInit, Inject, inject } from "@angular/core";
import { StandardService } from "../services/standard.service";
import {
  StandardTypeEnum,
  UserRoleEnum,
  StandardListType,
  AddendumStatusEnum,
} from "../core/constant";
import { Router, ActivatedRoute } from "@angular/router";
import { CryptographyService } from "../services/cryptography.service";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { SelectedStandard } from "../models/selected-standard";
import { NrbeStandard } from "../models/nrbestandard";
import { Attachment } from "../models/attachment";
import { FailModuleComponent } from "../fail-module/fail-module.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NrbesItem } from "../models/nrbesItem";
import { AddendumService } from "../services/addendum.service";
import linkifyStr from "linkifyjs/string";
import { debug } from "util";
import { DatePipe } from "@angular/common";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import DOMPurify from 'dompurify';
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackbarComponent } from "../snackbar/snackbar.component";

@Component({
  selector: "app-view-all-national-equipments-standard-detail-view",
  templateUrl:
    "./view-all-national-equipments-standard-detail-view.component.html",
  styleUrls: [
    "./view-all-national-equipments-standard-detail-view.component.scss",
  ],
  providers: [DatePipe],
})
export class ViewAllNationalEquipmentsStandardDetailViewComponent
  implements OnInit {
  private _snackBar = inject(MatSnackBar);
  detailsExpanded: boolean = false;
  allLocations: string = "";
  subLocations: string = "";
  grsId: number;

  loading: boolean = false;
  grsDetail: SelectedStandard = new SelectedStandard();
  userRole: number;
  error: string = "";
  nrbesId: number = 0;
  notes: SafeHtml = "";
  nrbesDetail: NrbeStandard = new NrbeStandard();
  get standardTypeEnum() {
    return StandardTypeEnum;
  }
  get userRoleEnum() {
    return UserRoleEnum;
  }

  get keyContactEmailResolved(): string {
    const d = (this.grsDetail || (this as any).nrbesDetail) as any;
    return (
      d?.keyContact?.email ||
      d?.keyContact?.Email ||
      d?.standard?.keyContact?.email ||
      d?.standard?.keyContact?.Email ||
      d?.standard?.email ||
      d?.standard?.Email ||
      d?.email ||
      d?.Email ||
      (this as any).keyContactEmail ||
      ""
    );
  }

  get linksList(): any[] {
    const d = (this.grsDetail || (this as any).nrbesDetail) as any;
    const rawLinks =
      d?.links ||
      d?.Links ||
      d?.standard?.links ||
      d?.standard?.Links ||
      d?.standard?.equipmentStandard?.links ||
      d?.standard?.equipmentStandard?.Links ||
      d?.standard?.equipmentStandard?.equipmentStandardLinks ||
      d?.standard?.equipmentStandard?.EquipmentStandardLinks ||
      d?.equipmentStandard?.links ||
      d?.equipmentStandard?.Links ||
      d?.equipmentStandard?.equipmentStandardLinks ||
      d?.equipmentStandard?.EquipmentStandardLinks ||
      d?.resourceLinks1 ||
      [];

    if (!Array.isArray(rawLinks)) return [];
    return rawLinks
      .map((l: any) => {
        const linkObj = l?.equipmentLink || l?.EquipmentLink || l?.link || l?.Link || l;
        const url = linkObj?.url || linkObj?.Url || "";
        const title = linkObj?.title || linkObj?.Title || linkObj?.name || linkObj?.Name || url;
        return { url, title };
      })
      .filter((l) => !!l.url?.trim() || !!l.title?.trim());
  }

  get hardwareDescription(): string {
    const d = (this.grsDetail || (this as any).nrbesDetail) as any;
    return (
      d?.keyContact?.emailDescription ||
      d?.keyContact?.EmailDescription ||
      d?.standard?.keyContact?.emailDescription ||
      d?.standard?.keyContact?.EmailDescription ||
      d?.standard?.emailDescription ||
      d?.standard?.EmailDescription ||
      d?.emailDescription ||
      d?.EmailDescription ||
      d?.keyContactDesc ||
      d?.standard?.keyContactDesc ||
      ""
    );
  }

  constructor(
    private router: Router,
    private standardService: StandardService,
    private cryptographyService: CryptographyService,
    @Inject(LOCAL_STORAGE)
    private storage: WebStorageService,
    private activeRoute: ActivatedRoute,
    private ngbModal: NgbModal,
    private addendumService: AddendumService,
    private datePipe: DatePipe,
    private sanitizer: DomSanitizer,

  ) {
    this.grsId = parseInt(this.activeRoute.snapshot.paramMap.get("grsId"));
  }

  ngOnInit() {
    this.userRole = this.cryptographyService.decryptData(
      this.storage.get("userRole")
    );
    this.getDetailByNrbesId(this.grsId);
  }

  /**
   * Get National Standard detail by standard id
   * @return void
   */
  getDetailByNrbesId(grsId: number) {
    this.loading = true;
    const rawCountryId =
      this.storage.get("selectedCountryId") ||
      this.storage.get("countryId") ||
      this.storage.get("adCountryId");
    const decryptedId = rawCountryId
      ? this.cryptographyService.decryptData(rawCountryId)
      : null;
    const countryIds = decryptedId != null && !isNaN(Number(decryptedId)) ? [Number(decryptedId)] : null;

    this.standardService
      .getNrbesDetailInfomationByNrbesId(
        grsId,
        countryIds,
        this.standardService.nationalEquipmentStandardFiltration.filterSet,
        this.standardService.nationalEquipmentStandardFiltration.searchKey,
        true
      )
      .subscribe((data: any) => {
        //debugger;
        try {
          data.country = [data.country];
          data.countryId = [data.countryId];
          this.nrbesDetail = new NrbeStandard(data);
          void 0;
          this.loading = false;
        } catch (e) {
          void 0;
        }
        this.nrbesDetail = new NrbeStandard(data);
        this.allLocations =
          this.nrbesDetail.standard.standardLocation.length > 0
            ? this.nrbesDetail.standard.standardLocation
              .map((loc: any) => loc.locationType.name)
              .join(", ")
            : this.nrbesDetail.standard.locationType.name;
        this.subLocations = this.nrbesDetail.standard.standardLocation
          .map((loc: any) =>
            loc.locationType.subLocationTypes?.length
              ? loc.locationType.subLocationTypes
                .map((sloc) => sloc.name)
                .join(", ")
              : "",
          )
          .filter(Boolean)
          .join(", ");
        const cleanNotes = DOMPurify.sanitize(this.nrbesDetail.standard.note);
        this.notes = this.sanitizer.bypassSecurityTrustHtml(cleanNotes);
        void 0;
        this.loading = false;
        (error: string) => {
          this.error = error;
          this.loading = false;
        };
      });
  }

  navigateAccToType(type, id) {
    if (type == 4) {
      this.router.navigate(["/minimum-standard-detail-view/" + id]);
      return;
    }
    if (type == 8) {
      this.router.navigate(["/operations-standards-detail-view/" + id]);
      return;
    }
    if (type == 0) {
      this.router.navigate(["/view-equipments-standard-detail/" + id]);
      return;
    }
    if (type == 1 || type == 2) {
      this.router.navigate(["/global-recommendations-detail-view/" + id]);
      return;
    }
  }

  slide(sID: number, isForward: boolean) {
    // this.loading = true;
    this.standardService
      .getNextPreviousNrbsInfomationByCurrentNrbesId(
        sID,
        isForward,
        [
          this.cryptographyService.decryptData(
            this.storage.get("selectedCountryId")
          ),
        ],
        this.standardService.nationalEquipmentStandardFiltration.filterSet,
        this.standardService.nationalEquipmentStandardFiltration.searchKey,
        true
      )
      .subscribe((data: any) => {
        this.router.navigate([
          "view-national-equipments-standard-detail",
          data.id,
        ]);
        this.nrbesDetail = new NrbeStandard(data);
        const cleanNotes = DOMPurify.sanitize(this.nrbesDetail.standard.note);
        this.notes = this.sanitizer.bypassSecurityTrustHtml(cleanNotes);
        this.loading = false;
        (error: string) => {
          this.error = error;
          this.loading = false;
        };
      });
  }

  onDownloadSelectedEquipmentAttachment(e) {
    return this.standardService.getAttachmentUrl(e.id, false).subscribe(
      (response: any) => {
        const blob = new Blob([response], {
          type: response.type,
        });
        if (
          (window.navigator as any) &&
          (window.navigator as any).msSaveOrOpenBlob
        ) {
          (window.navigator as any).msSaveOrOpenBlob(blob, e.fileName);
          return;
        }
        var a = document.createElement("a");
        document.body.appendChild(a);

        let url = window.URL.createObjectURL(blob);

        a.href = url;
        a.download = e.fileName;
        a.click();
        window.URL.revokeObjectURL(url);

        //window.open(url);
      },
      (error: any) => {
        const modalRef = this.ngbModal.open(FailModuleComponent);
        modalRef.componentInstance.errorMessage = error.error
          ? error.error.Message
          : error.message;
      }
    );
  }

  addAddendum(standardId: number, event): void {
    event.stopPropagation();
    this.storage.set(
      "adCountryId",
      this.cryptographyService.encryptData(
        this.nrbesDetail.country.map((c) => c.id).length > 0
          ? this.nrbesDetail.country.map((c) => c.id)[0]
          : 0
      )
    );
    this.router.navigate(["/add-addendum/" + standardId]);
  }

  goToAddendum(nrbesItem: any): void {
    void 0;
    try {
      this.storage.set("adCountryId", nrbesItem.country);
      this.router.navigate(["/addendum/" + nrbesItem.availabileAddendumId]);
    } catch (e) {
      void 0;
    }
  }

  getLocationNames(item): any {
    if (
      item.standard.standardLocation &&
      item.standard.standardLocation.length > 0
    ) {
      return item.standard.standardLocation
        .map((loc) => loc.locationType.name)
        .join(", ");
    } else {
      return item.standard.locationType.name;
    }
  }
  toggleDetails() {
    this.detailsExpanded = !this.detailsExpanded;
  }

  getDetails() {
    return this.sanitizer.bypassSecurityTrustHtml(
      this.grsDetail.standard.note.replace(/\n/g, "<br>"),
    );
  }

  openSnackBar() {
    this._snackBar.openFromComponent(SnackbarComponent, {
      duration: 2000,
      data: {
        message: "Object Copied to clipboard!",
      },
    });
  }
  copyText(content: any) {
    void 0;
    navigator.clipboard.writeText(content);
    this.openSnackBar();
  }

  goBack() {
    this.router.navigate(["/view-all-equipments"]);
  }
}
